import { useRequest } from 'ahooks';
import { EditableTableFormInstance } from 'react-pro-components/typings/components/editable-table-2/types';
import { message } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { setWorkstationActivityType } from '../api';
import { WorkstationActivityType } from '../type';

export const useHandleForm = (form: EditableTableFormInstance<WorkstationActivityType>, refresh: (data: any) => Promise<any>) => {
  const { run, loading } = useRequest(setWorkstationActivityType, {
    manual: true,
    onSuccess() {
      message.success($gt('Succeeded!'));
      refresh({});
    },
  });
  const submit = () => {
    const formValues = form.getRowsValues();
    const submitValues = formValues.map((activityType: WorkstationActivityType) => {
      return { ...activityType };
    });
    run({ list: submitValues });
  };

  return {
    submit,
    loading,
  };
};
